module.exports = __webpack_public_path__ + "static/banderhobb-233fd738d3e4d02da73d6a04af1920a2.jpeg";